module.exports = __webpack_public_path__ + "img/currencyEle.e0b09055.svg";